export * from './lib/strip-extra-words';